
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: "pay-success",
components: {
XHeader
},
data() {
return {
title: "查成绩",
total:'100'
}
}
}



// WEBPACK FOOTER //
// ./src/components/ScoreFailed.vue